// extracted by mini-css-extract-plugin
module.exports = {"root":"_39o2d","loader":"_3yY0d","spin":"_1zgVL"};